<div class="panel panel-default">
    <div class="panel-heading">
        <div class="panel-title">Upcoming Tasks</div>
    </div>
    <div class="panel-body">
        <div *ngIf="!isLoaded" class="whirl standard spinnermargin"></div>
        <ng-template [ngIf]="isLoaded">
            <div *ngIf="tasks.length > 0" class="table-responsive">
                <table class="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th>Contact</th>
                            <th>Type</th>
                            <th>Priority</th>
                            <th>Start</th>
                            <th>Finish</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let t of tasks">
                            <td>{{ t.contact_name }}</td>
                            <td>{{ t.type }}</td>
                            <td>
                                <span class="badge" [ngClass]="getPriorityClass(t.priority)">{{ t.priority }}</span>
                            </td>
                            <td>{{ t.start }}</td>
                            <td>{{ t.finish }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="tasks.length === 0" class="text-center text-muted py-lg">
                No upcoming tasks.
            </div>
        </ng-template>
    </div>
</div>